import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocalizationPin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icons",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M9.5 9C8.675 9 8 8.325 8 7.5C8 6.675 8.675 6 9.5 6C10.325 6 11 6.675 11 7.5C11 8.325 10.325 9 9.5 9ZM14 7.65C14 4.9275 12.0125 3 9.5 3C6.9875 3 5 4.9275 5 7.65C5 9.405 6.4625 11.73 9.5 14.505C12.5375 11.73 14 9.405 14 7.65ZM9.5 1.5C12.65 1.5 15.5 3.915 15.5 7.65C15.5 10.14 13.4975 13.0875 9.5 16.5C5.5025 13.0875 3.5 10.14 3.5 7.65C3.5 3.915 6.35 1.5 9.5 1.5Z",
			fill: "white"
		})
	})
});
export default SvgLocalizationPin;
